/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { Form, Button, Spinner, Modal } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import ProductCostHttpService from '../../../../services/http/product-cost-http';
import handleResponseError from '../../../../utils/handleResponseError';


interface ProductCostForm {
    productErpCode: string;
    productCost: number;
}

interface ProductCostModalProps {
    isEdit: boolean;
    selectedCost: any;
    update: () => void;
    isOpen: (value: boolean) => void;
    onHide: () => void;
    show: boolean;
}

const ProductCostModal = ({
    isEdit,
    selectedCost,
    update,
    isOpen,
    onHide,
    show,
}: ProductCostModalProps) => {
    const [loading, setLoading] = useState(false);

    const {
        control,
        watch,
        reset,
        setValue,
    } = useForm<ProductCostForm>({
        shouldUnregister: false,
        defaultValues: {
            productErpCode: '',
            productCost: 0,
        },
    });

    const fieldsData = watch();

    const createProductCost = async () => {
        setLoading(true);

        try {
            const payload = {
                productErpCode: fieldsData.productErpCode,
                productCost: Number(fieldsData.productCost),
            };

            const response =
                await ProductCostHttpService.saveProductCost(
                    payload
                );

            if (response) {
                update();
                isOpen(false);

                toast.success(
                    'Custo do produto cadastrado com sucesso!'
                );
            }
        } catch (err: any) {
            handleResponseError(
                err,
                'Ocorreu um erro ao salvar o custo do produto.'
            );
        } finally {
            setLoading(false);
            onHide();
        }
    };

    const editProductCost = async () => {
        setLoading(true);

        try {
            const payload = {
                productErpCode:
                    selectedCost.productErpCode,
                productCost: Number(fieldsData.productCost),
            };

            const response =
                await ProductCostHttpService.editProductCost(
                    payload,
                    selectedCost.id
                );

            if (response) {
                update();
                isOpen(false);

                toast.success(
                    'Custo do produto atualizado com sucesso!'
                );
            }
        } catch (err: any) {
            handleResponseError(
                err,
                'Ocorreu um erro ao atualizar o custo do produto.'
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!isEdit) {
            reset({
                productErpCode: selectedCost.B1_COD || '',
                productCost: 0,
            });
        } else {
            setValue(
                'productErpCode',
                selectedCost.productErpCode || ''
            );

            setValue(
                'productCost',
                selectedCost.unitCost || 0
            );
        }
    }, [show, isEdit, reset]);

    return (
        <Modal
            className="modal-dialog-scrollable"
            show={show}
            onHide={onHide}
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title
                    className="ml-3 mr-3"
                    id="contained-modal-title-vcenter"
                >
                    {isEdit
                        ? 'Editar custo do produto'
                        : 'Novo custo de produto'}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="w-100">
                <Form.Group controlId="productErpCode">
                    <Form.Label>
                        Código ERP do Produto
                    </Form.Label>

                    <Controller
                        control={control}
                        name="productErpCode"
                        rules={{
                            required: 'Campo obrigatório',
                        }}
                        render={({ value, onChange }) => (
                            <Form.Control
                                type="text"
                                value={value}
                                onChange={onChange}
                                disabled={isEdit}
                            />
                        )}
                    />
                </Form.Group>

                <Form.Group controlId="productCost">
                    <Form.Label>
                        Custo Unitário (R$)
                    </Form.Label>

                    <Controller
                        control={control}
                        name="productCost"
                        rules={{
                            required: 'Campo obrigatório',
                        }}
                        render={({ value, onChange }) => (
                            <Form.Control
                                type="number"
                                min={0}
                                step="0.01"
                                value={value}
                                onChange={onChange}
                            />
                        )}
                    />
                </Form.Group>
            </Modal.Body>

            <Modal.Footer className="ml-3 mr-3 mb-2">
                <Button
                    variant="outline-primary"
                    style={{ width: '150px' }}
                    onClick={() => {
                        reset();
                        isOpen(false);
                    }}
                >
                    Cancelar
                </Button>

                <Button
                    style={{ width: '150px' }}
                    onClick={
                        isEdit
                            ? editProductCost
                            : createProductCost
                    }
                >
                    {loading ? (
                        <Spinner animation="border" />
                    ) : (
                        'Salvar'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ProductCostModal;